var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{staticClass:"status-durations",attrs:{"transform":"translate(1515, 40)"}},[_c('text',{staticClass:"status-duration",attrs:{"transform":"translate(0, 30)","dy":"0.35em"}},[_vm._v(_vm._s((new Date(_vm.off
      .map((x) => x.dur)
      .reduce((acc, item) => {
        return (acc += item);
      }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]))]),_c('text',{staticClass:"status-duration",attrs:{"transform":"translate(0, 70)","dy":"0.35em"}},[_vm._v("\n    "+_vm._s((new Date(_vm.sb
      .map((x) => x.dur)
      .reduce((acc, item) => {
        return (acc += item);
      }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]))]),_c('text',{staticClass:"status-duration",attrs:{"transform":"translate(0, 110)","dy":"0.35em"}},[_vm._v(_vm._s((new Date(_vm.dr
      .map((x) => x.dur)
      .reduce((acc, item) => {
        return (acc += item);
      }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]))]),_c('text',{staticClass:"status-duration",attrs:{"transform":"translate(0, 150)","dy":"0.35em"}},[_vm._v(_vm._s((new Date(_vm.on
      .map((x) => x.dur)
      .reduce((acc, item) => {
        return (acc += item);
      }, 0) * 1000)).toUTCString().match(/(\d\d:\d\d)/)[0]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }